export const TIME_ZONE_COOKIE_NAME = "rallly_time_zone";
export const TIME_ZONE_OVERRIDE_COOKIE_NAME = "rallly_time_zone_override";
export const TIME_FORMAT_COOKIE_NAME = "rallly_time_format";
